"use client";

import React from "react";

import useFetchFaqDetail from "../../lib/hooks/use-fetch-faq-detail";
import { Link, useParams } from "react-router-dom";
import EditFaqForm from "./ui/edit-faq-form";

const EditFaq = () => {
    const params:any = useParams();
const {data:res} = useFetchFaqDetail(params.id);
  const page = res.status
    ? res.data
    : null;




  return (
    <React.Fragment>
            <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
                    <Link to="/admin/faq">FAQ</Link>
          <span>Edit FAQ</span>
        </div>
      </div>
{page ? <EditFaqForm page={page}/> : <div>Loading...</div>}
    </React.Fragment>
  );
};

export default EditFaq;
